import React, { createContext, useMemo } from 'react';
import { IFulfillmentGroup } from '../models/order-details';
import { FULFILLMENT_TYPE } from '../constants/status';

export interface IFulfillmentGroupContext {
  fulfillmentGroup: IFulfillmentGroup;
  fulfillmentType: FULFILLMENT_TYPE;
  fulfillmentGroupIndex: number;
}

type FulfillmentGroupProviderProps = {
  children: React.ReactNode;
} & IFulfillmentGroupContext;

export const FulfillmentGroupContext = createContext<
  IFulfillmentGroupContext | undefined
>(undefined);

export function FulfillmentGroupProvider({
  children,
  fulfillmentGroup,
  fulfillmentType,
  fulfillmentGroupIndex,
}: FulfillmentGroupProviderProps) {
  const value = useMemo<IFulfillmentGroupContext>(() => {
    return {
      fulfillmentGroup,
      fulfillmentGroupIndex,
      fulfillmentType,
    };
  }, [fulfillmentGroup, fulfillmentType, fulfillmentGroupIndex]);

  return (
    <FulfillmentGroupContext.Provider value={value}>
      {children}
    </FulfillmentGroupContext.Provider>
  );
}
